import React, {useCallback, useState, ReactNode} from 'react';
import I18n from 'app/i18n';
import {articlesStore} from 'app/store/global';
import {userSignedIn} from 'app/utils';
import {openRegistration} from 'app/components/auth/auth';
import {toastError, toastInfo, toastSuccess} from 'app/components/toasts/liteToast';

interface ParticipatePromoButtonProps {
    isParticipating: boolean
    promoId: number
    title: string
    authPlacement: string
    className: string
    onParticipated?: () => void
}

export default function ParticipatePromoButton(props: ParticipatePromoButtonProps): ReactNode {
    const [loading, setLoading] = useState(false);
    const {isParticipating, promoId, title, authPlacement, className, onParticipated} = props;

    const handleParticipate = useCallback(async(): Promise<void> => {
        if (!userSignedIn()) {
            openRegistration(authPlacement, null, 'login');
            return;
        }
        if (loading) {
            return;
        }
        if (isParticipating) {
            toastInfo(I18n.t('bonuses_page.already_participating_toast'));
            return;
        }
        setLoading(true);
        try {
            await articlesStore.participateInPromo(promoId);
            toastSuccess(I18n.t('bonuses_page.participating_toast', {promoName: title}));
            onParticipated?.();
        } catch (_e) {
            toastError(I18n.t('server_error_try_later'));
        } finally {
            setLoading(false);
        }
    }, [
        isParticipating,
        loading,
        promoId,
        title,
        onParticipated
    ]);

    return (
        <button
            type="button"
            className={`${className} ${isParticipating ? 'participated' : ''}`}
            onClick={handleParticipate}
            disabled={loading}
        >
            {I18n.t('bonuses_page.participate')}
        </button>
    );
}
